import { useCallback, useEffect, useState } from "react";

import { fetchNotifications, unwrapNotificationsPayload } from "../services/notificationService";

export const NOTIFICATIONS_UPDATED_EVENT = "notifications-updated";

export function notifyNotificationsUpdated() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(NOTIFICATIONS_UPDATED_EVENT));
  }
}

export default function useNotificationUnreadCount() {
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const { data } = await fetchNotifications();
      const { unread_count: n } = unwrapNotificationsPayload(data);
      setUnreadCount(Number(n) || 0);
    } catch {
      setUnreadCount(0);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onUpdate = () => refresh();
    window.addEventListener(NOTIFICATIONS_UPDATED_EVENT, onUpdate);
    const interval = window.setInterval(refresh, 60000);
    return () => {
      window.removeEventListener(NOTIFICATIONS_UPDATED_EVENT, onUpdate);
      window.clearInterval(interval);
    };
  }, [refresh]);

  return { unreadCount, refresh };
}
